import { useContext } from 'react';
import { LastLocationContext } from 'context/last-location-provider/last-location.context';

export const useLastLocation = () => {
    return useContext(LastLocationContext);
}
